import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65c4a654"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "c-modal-cover"
}
const _hoisted_2 = { class: "c-modal-header" }
const _hoisted_3 = { class: "c-modal-title" }
const _hoisted_4 = { class: "c-modal-icons" }
const _hoisted_5 = { class: "c-modal-footer" }
const _hoisted_6 = { calss: "c-modal-footer-btns" }

import CButton from '../cButton/CButton.vue';
interface ModalProps {
  width?: number,
  height?: number,
  title?: string,
  visible: boolean,
  centered?: boolean
}

const __default__ = {
  name:'CModal'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    width: { default: 600 },
    height: {},
    title: {},
    visible: { type: Boolean },
    centered: { type: Boolean, default: false }
  },
  emits: ['update:visible'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const closeModal = () => {
  emit('update:visible', false)
}

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "c-modal-container",
          style: _normalizeStyle('width:' + _ctx.width + 'px;height:' + _ctx.height + 'px')
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_svg_icon, {
                icon: "close",
                onClick: closeModal
              })
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["c-modal-body", { 'flex-center': _ctx.centered }])
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 2),
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "footer", {}, () => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(CButton, {
                  text: "返回",
                  onClick: closeModal
                })
              ])
            ])
          ])
        ], 4)
      ]))
    : _createCommentVNode("", true)
}
}

})